.dialog-wrapper div[mat-dialog-content]{margin:15px 0}.dialog-wrapper div[mat-dialog-actions]{display:flex;justify-content:flex-end;align-items:center}
/*# sourceMappingURL=description-dialog.component-MC6VYJR6.css.map */
